import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: WebSite → home
export const Route = createFileRoute("/website")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
  component: () => null,
});
